var render = function render(){
  var _vm$collaborators;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "protocol_search_item"
  }, [_c('div', {
    staticClass: "top_info"
  }, [_c('div', {
    staticClass: "txt_cont"
  }, [_c('div', {
    staticClass: "tit_label"
  }, [_c('span', {
    staticClass: "condition",
    class: _vm.publicActive != 0 ? 'open' : null
  }, [_vm._v(_vm._s(_vm.publicActiveList[_vm.publicActive]))]), _vm.uniqueNumber ? _c('span', {
    staticClass: "label_color color_01",
    domProps: {
      "innerHTML": _vm._s(_vm.uniqueNumber)
    }
  }) : _c('span', {
    staticClass: "label_color color_01",
    domProps: {
      "innerHTML": _vm._s('공정도')
    }
  }), _c('span', {
    staticClass: "label_gray"
  }, [_vm._v(_vm._s(`${_vm.fieldName.split(">").join(" / ")}`))])]), _c('a', {
    staticClass: "tit_link",
    attrs: {
      "href": "javascript:void(0);"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.processName)
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('goToProcessDetail');
      }
    }
  })]), _c('div', {
    staticClass: "img_cont"
  }, [_c('div', {
    staticClass: "img_box"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('goToProcessDetail');
      }
    }
  }, [_c('img', {
    staticClass: "template",
    attrs: {
      "src": `data:image/jpeg;base64,${_vm.thumbnail}`
    }
  })])])])]), _c('div', {
    staticClass: "bottom_info"
  }, [_c('ul', {
    staticClass: "user_set"
  }, [_c('li', [_vm._v(_vm._s(_vm.lastEditDate))]), _c('li', [_vm._v("책임작성자 : " + _vm._s(_vm.userName))]), (_vm$collaborators = _vm.collaborators) !== null && _vm$collaborators !== void 0 && _vm$collaborators.length ? _c('li', [_vm._v("공동작성자 : "), _vm._l(_vm.collaborators, function (collaborator, collaboratorKey) {
    return _c('span', {
      key: collaboratorKey
    }, [_vm._v(_vm._s(`${collaboratorKey != 0 ? " ," + (!collaborator.userName ? collaborator.name : collaborator.userName) : !collaborator.userName ? collaborator.name : collaborator.userName}`) + " ")]);
  })], 2) : _vm._e()]), _c('ul', {
    staticClass: "btn_set"
  }, [_vm.thisMyPage ? _c('li', [_vm.thisMyPage ? _c('a', {
    staticClass: "editor_move_btn",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('goToProcessEditor');
      }
    }
  }, [_vm._v("에디터로 이동 ")]) : _vm._e()]) : _vm._e()])]), _c('IncludedProtocols', {
    attrs: {
      "inProcessId": _vm.inProcessId,
      "lastEditDate": _vm.lastEditDate,
      "active": _vm.includedProtocolsActive,
      "publishingActive": _vm.publishingActive,
      "searchFlag": true
    },
    on: {
      "goToDetail": _vm.goToDetail,
      "close": function ($event) {
        _vm.includedProtocolsActive = false;
      },
      "goToProcessDetail": function ($event) {
        return _vm.$emit('goToProcessDetail');
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }